import { useQuery } from '@apollo/client';

import { type SalesChartFilter } from '@/app/[locale]/(authorized)/(dashboard)/components/Dashboard/components/Charts/components/SalesChart/components/SalesChartFilter';
import SalesChart from '@/graphql/dashboard/SalesChart';
import { useCommonApolloOptions } from '@/hooks/use-common-apollo-options';
import { type Defined } from '@/types/common';

import type { SalesChartQuery } from '../../../../../../../../../../generated/graphql';

type UseSalesChartOptions = {
  filter?: SalesChartFilter;
  gateGroupId?: string;
};

export type SalesChartData = Defined<SalesChartQuery['dashboardWidgetsSalesChartV2']>;

export function useSalesChartData(options: UseSalesChartOptions) {
  const { filter, gateGroupId } = options;

  const apolloOptions = useCommonApolloOptions();

  return useQuery(SalesChart, {
    ...apolloOptions,
    variables: filter
      ? {
          period: filter.period,
          currency_id: filter.currency.id,
          operation_type: filter.operationType,
          gate_group_id: gateGroupId,
        }
      : undefined,
    skip: !filter,
  });
}
